import Axios from "axios";
const CancelToken = Axios.CancelToken;

const path = "https://server.finkegabriel.com/nash";

const server = {
  get(request) {
    const axios = Axios.create({ baseURL: path });
    const source = CancelToken.source();
    const promise = axios.get(request, { cancelToken: source.token });
    return { promise, cancel: source.cancel };
  },

  post(request, body) {
    if (!body) body = {};
    if (!body.token) body.token = localStorage.token;
    const axios = Axios.create({ baseURL: path });
    const source = CancelToken.source();
    const promise = axios.post(request, body, { cancelToken: source.token });
    return { promise, cancel: source.cancel };
  },

  initWebSocket() {
    let url;
    if (window.location.protocol === "https:") {
      url = "wss://" + path + "/nash";
      if (process.env.SERVER_PATH !== "/nash") {
        url = process.env.SERVER_PATH.replace("http", "wss");
      }
    } else {
      console.log("using non secure http", path);
      url = "ws://" + path + "/nash";
      if (path !== "/nash") {
        url = path.replace("http", "ws");
      }
    }
    return new WebSocket(url, "nash");
  },
};

export default server;



// WEBPACK FOOTER //
// ./src/server.js